export default __webpack_public_path__ + "static/media/circle05.57809c41.svg";